import {
  Refrigerator,
  WashingMachine,
  Wind,
  UtensilsCrossed,
  Flame,
  Snowflake,
  Microwave,
} from "lucide-react";

export const PHONE_DISPLAY = "905-906-6836";
export const PHONE_TEL = "tel:+19059066836";
export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const NAV_LINKS = [
  { label: "Services", id: "services" },
  { label: "Why Us", id: "why-us" },
  { label: "Reviews", id: "reviews" },
  { label: "Areas", id: "service-areas" },
  { label: "FAQ", id: "faq" },
];

export const SERVICES = [
  {
    slug: "refrigerator",
    name: "Refrigerator Repair",
    tagline: "Not cooling, leaking, or loud compressor noises? Fast sealed-system & defrost fixes.",
    image:
      "https://images.unsplash.com/photo-1639405069836-f82aa6dcb900?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODh8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBzdGFpbmxlc3MlMjByZWZyaWdlcmF0b3IlMjBraXRjaGVuJTIwaW50ZXJpb3J8ZW58MHx8fHwxNzg3ODY0NTk5fDA&ixlib=rb-4.1.0&q=85",
    icon: Refrigerator,
    badges: ["Same-Day", "All Brands"],
  },
  {
    slug: "washer",
    name: "Washer Repair",
    tagline: "Won't drain, spin, or leaking water? Front & top-load experts, pumps to bearings.",
    image:
      "https://images.unsplash.com/photo-1626806819282-2c1dc01a5e0c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTV8MHwxfHNlYXJjaHwxfHx3YXNoaW5nJTIwbWFjaGluZSUyMGxhdW5kcnklMjByb29tJTIwbW9kZXJufGVufDB8fHx8MTc4Nzg2NDU5OXww&ixlib=rb-4.1.0&q=85",
    icon: WashingMachine,
    badges: ["Drainage", "Motor & Belt"],
  },
  {
    slug: "dryer",
    name: "Dryer Repair",
    tagline: "No heat, burning smell, or drum won't turn? Electric & gas dryer specialists.",
    image:
      "https://images.unsplash.com/photo-1646592474094-342fbc28736c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTV8MHwxfHNlYXJjaHw0fHx3YXNoaW5nJTIwbWFjaGluZSUyMGxhdW5kcnklMjByb29tJTIwbW9kZXJufGVufDB8fHx8MTc4Nzg2NDU5OXww&ixlib=rb-4.1.0&q=85",
    icon: Wind,
    badges: ["Heating Element", "Thermal Fuse"],
  },
  {
    slug: "dishwasher",
    name: "Dishwasher Repair",
    tagline: "Dishes still dirty, standing water, or door latch failure? Pump & spray arm fixes.",
    image:
      "https://images.unsplash.com/photo-1732044790214-2930623d3edc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODh8MHwxfHNlYXJjaHw0fHxtb2Rlcm4lMjBzdGFpbmxlc3MlMjByZWZyaWdlcmF0b3IlMjBraXRjaGVuJTIwaW50ZXJpb3J8ZW58MHx8fHwxNzg3ODY0NTk5fDA&ixlib=rb-4.1.0&q=85",
    icon: UtensilsCrossed,
    badges: ["Water Leaks", "Sanitize Cycle"],
  },
  {
    slug: "stove-oven",
    name: "Stove & Oven Repair",
    tagline: "Burners won't ignite, inaccurate temperature, or cracked glass cooktop issues.",
    image:
      "https://images.unsplash.com/photo-1610733374054-59454fe657cd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODh8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjBzdGFpbmxlc3MlMjByZWZyaWdlcmF0b3IlMjBraXRjaGVuJTIwaW50ZXJpb3J8ZW58MHx8fHwxNzg3ODY0NTk5fDA&ixlib=rb-4.1.0&q=85",
    icon: Flame,
    badges: ["Gas & Electric", "Control Board"],
  },
  {
    slug: "freezer",
    name: "Freezer Repair",
    tagline: "Frost buildup, warm spots, or total breakdown? Chest, upright & built-in units.",
    image:
      "https://images.unsplash.com/photo-1613545564259-ede280773613?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODh8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBzdGFpbmxlc3MlMjByZWZyaWdlcmF0b3IlMjBraXRjaGVuJTIwaW50ZXJpb3J8ZW58MHx8fHwxNzg3ODY0NTk5fDA&ixlib=rb-4.1.0&q=85",
    icon: Snowflake,
    badges: ["Quick Diagnostics", "Built-In Units"],
  },
  {
    slug: "microwave",
    name: "Microwave Repair",
    tagline: "No heat, dead display, or turntable not spinning? Magnetron & door switch repairs.",
    image:
      "https://images.unsplash.com/photo-1639405069836-f82aa6dcb900?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODh8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBzdGFpbmxlc3MlMjByZWZyaWdlcmF0b3IlMjBraXRjaGVuJTIwaW50ZXJpb3J8ZW58MHx8fHwxNzg3ODY0NTk5fDA&ixlib=rb-4.1.0&q=85",
    icon: Microwave,
    badges: ["Over-Range", "Countertop"],
  },
];

export const APPLIANCE_OPTIONS = [
  "Refrigerator",
  "Washer",
  "Dryer",
  "Dishwasher",
  "Stove / Oven",
  "Freezer",
  "Microwave",
  "Other",
];

export const REVIEWS = [
  {
    author: "Marcus Vance",
    location: "North York, Toronto",
    appliance: "Samsung Refrigerator",
    comment:
      "Our fridge stopped cooling on a Saturday morning. The technician arrived within 2 hours with the exact replacement part, and the $80 service fee was waived right off the repair bill. Exceptional service!",
    date: "2 days ago",
  },
  {
    author: "Elena Rostova",
    location: "Mississauga",
    appliance: "LG Front-Load Washer",
    comment:
      "Super professional and honest! Diagnosed our washing machine leak in 15 minutes and fixed it on the spot. Very clean work and fair, upfront pricing.",
    date: "1 week ago",
  },
  {
    author: "David Chen",
    location: "Etobicoke",
    appliance: "Bosch Dishwasher",
    comment:
      "High-quality repair service. The technician explained everything clearly before starting and the price matched the quote exactly. I have 905-906-6836 saved in my phone now!",
    date: "2 weeks ago",
  },
  {
    author: "Priya Sharma",
    location: "Brampton",
    appliance: "Whirlpool Dryer",
    comment:
      "Dryer had zero heat and two kids' worth of laundry piling up. They booked me same-day, replaced the heating element in under an hour, and honoured the 90-day warranty in writing. Highly recommend.",
    date: "3 weeks ago",
  },
];

export const AREAS = [
  "Toronto — Downtown",
  "North York",
  "Scarborough",
  "Etobicoke",
  "Mississauga",
  "Brampton",
  "Vaughan",
  "Markham",
  "Richmond Hill",
  "Oakville",
  "Burlington",
  "Ajax & Pickering",
  "Milton",
  "Newmarket & Aurora",
  "Whitby & Oshawa",
  "Woodbridge",
];

export const FAQS = [
  {
    q: "How does the $80 service call fee waiver work?",
    a: "When our technician diagnoses your appliance in person, the service call is $80. If you choose to proceed with the recommended repair, we waive the entire $80 — you only pay for the repair itself.",
  },
  {
    q: "How much will my repair cost?",
    a: "We charge per job, never per hour — you approve a flat, upfront quote before any work begins. Repairs start at only $80, and remember: the $80 service call is waived when you proceed with the repair.",
  },
  {
    q: "Do you really offer same-day appliance repair in Toronto & the GTA?",
    a: "Yes. We keep fully equipped repair vans stationed across Toronto, Mississauga, Brampton, Vaughan, Markham and surrounding GTA areas, so we can offer same-day appointments 7 days a week. Call before noon and we can almost always get a technician to you the same day.",
  },
  {
    q: "What warranty do you provide on repairs?",
    a: "Every repair is backed in writing by a 1-year warranty on parts and a 30-day warranty on labour. If the same issue comes back within the warranty period, we return and make it right at no charge.",
  },
  {
    q: "Which appliance brands do you repair?",
    a: "We repair all major household brands including Samsung, LG, Whirlpool, Bosch, GE, Maytag, KitchenAid, Frigidaire, Kenmore, Miele, Sub-Zero, Viking and more — gas and electric models alike.",
  },
  {
    q: "Are your technicians licensed and insured?",
    a: "Absolutely. Every GTA Appliance Rescue technician is fully licensed, insured, background-checked and factory-trained across all major appliance brands.",
  },
];

export const BRANDS = [
  "Samsung",
  "LG",
  "Whirlpool",
  "Bosch",
  "Maytag",
  "GE Appliances",
  "KitchenAid",
  "Frigidaire",
  "Kenmore",
  "Sub-Zero",
  "Miele",
  "Viking",
];

export const MARQUEE_ITEMS = [
  "Same-Day Service 7 Days a Week",
  "$80 Service Call Waived With Repair",
  "Repairs Start at Only $80 — Flat Per-Job Pricing",
  "1-Year Parts & 30-Day Labour Warranty",
  "Licensed & Insured Technicians",
  "Toronto • Mississauga • Brampton • Vaughan • Markham",
  "4.9★ Rated by 1,480+ GTA Homeowners",
];

export const SERVICE_PAGES = {
  refrigerator: {
    h1: "Refrigerator Repair in Toronto & the GTA",
    intro:
      "A warm fridge can't wait. Our technicians carry the most common refrigerator parts on the van — compressors, fans, thermostats and defrost systems — so most fridge repairs across Toronto and the GTA are completed in a single visit.",
    problems: [
      "Fridge not cooling but freezer works",
      "Leaking water onto the floor",
      "Loud humming, buzzing or clicking noises",
      "Ice maker not making ice",
      "Frost buildup in the freezer section",
      "Fridge running constantly or cycling too often",
    ],
    metaTitle: "Refrigerator Repair Toronto & GTA | GTA Appliance Rescue",
    metaDesc:
      "Same-day refrigerator repair in Toronto & the GTA. Not cooling, leaking or noisy? Certified techs for Samsung, LG, Whirlpool & more. Call 905-906-6836.",
  },
  washer: {
    h1: "Washer Repair in Toronto & the GTA",
    intro:
      "Front-load or top-load, we fix them all. From drain pumps and door seals to motors and control boards, our vans carry the parts that fail most — so your laundry pile stops growing today, not next week.",
    problems: [
      "Washer won't drain or spin",
      "Water leaking from the door or underneath",
      "Loud banging or shaking during spin cycle",
      "Won't start or stops mid-cycle",
      "Door or lid won't lock / unlock",
      "Error codes on the display",
    ],
    metaTitle: "Washer Repair Toronto & GTA | GTA Appliance Rescue",
    metaDesc:
      "Same-day washing machine repair in Toronto & the GTA. Won't drain, spin or leaking? Front & top-load experts. Flat per-job pricing. Call 905-906-6836.",
  },
  dryer: {
    h1: "Dryer Repair in Toronto & the GTA",
    intro:
      "No heat, long dry times or a burning smell are all safety-relevant symptoms — don't keep running the machine. We repair electric and gas dryers across Toronto and the GTA, usually in one visit.",
    problems: [
      "Dryer runs but produces no heat",
      "Drum won't turn or tumbling is loud",
      "Burning smell or overheating",
      "Takes two or three cycles to dry",
      "Dryer won't start at all",
      "Shuts off mid-cycle",
    ],
    metaTitle: "Dryer Repair Toronto & GTA | GTA Appliance Rescue",
    metaDesc:
      "Same-day dryer repair in Toronto & the GTA. No heat, drum not turning or burning smell? Electric & gas dryer experts. Call 905-906-6836.",
  },
  dishwasher: {
    h1: "Dishwasher Repair in Toronto & the GTA",
    intro:
      "Standing water, dirty dishes or a door that won't latch — we diagnose it in person and quote you a flat per-job price before any work begins. Most dishwasher repairs finish in a single visit.",
    problems: [
      "Dishes come out dirty or cloudy",
      "Standing water at the bottom — not draining",
      "Leaking onto the kitchen floor",
      "Door latch or hinge failure",
      "Won't start or fills with no spray",
      "Strange grinding or humming sounds",
    ],
    metaTitle: "Dishwasher Repair Toronto & GTA | GTA Appliance Rescue",
    metaDesc:
      "Same-day dishwasher repair in Toronto & the GTA. Not draining, leaking or dishes still dirty? Bosch, Samsung, LG & all brands. Call 905-906-6836.",
  },
  "stove-oven": {
    h1: "Stove & Oven Repair in Toronto & the GTA",
    intro:
      "Gas or electric, coil, smooth-top or induction — our licensed technicians repair all cooking appliances. Burners that won't ignite and ovens that won't hold temperature are our most common same-day calls.",
    problems: [
      "Burner won't ignite or stays on high",
      "Oven not heating to the set temperature",
      "Uneven baking or broiling",
      "Cracked or damaged glass cooktop",
      "Oven door won't close or lock",
      "Display or control board not responding",
    ],
    metaTitle: "Stove & Oven Repair Toronto & GTA | GTA Appliance Rescue",
    metaDesc:
      "Same-day stove & oven repair in Toronto & the GTA. Gas and electric — burners, elements, control boards & glass cooktops. Call 905-906-6836.",
  },
  freezer: {
    h1: "Freezer Repair in Toronto & the GTA",
    intro:
      "A failing freezer puts hundreds of dollars of food at risk. We treat freezer calls as priority — chest, upright and built-in freezers across Toronto and the GTA, with most repairs done on the first visit.",
    problems: [
      "Freezer not freezing or running warm",
      "Heavy frost or ice buildup",
      "Compressor clicking on and off",
      "Water pooling under the unit",
      "Door seal not closing tightly",
      "Freezer running non-stop",
    ],
    metaTitle: "Freezer Repair Toronto & GTA | GTA Appliance Rescue",
    metaDesc:
      "Same-day freezer repair in Toronto & the GTA. Not freezing, frost buildup or leaks? Chest, upright & built-in units. Call 905-906-6836.",
  },
  microwave: {
    h1: "Microwave Repair in Toronto & the GTA",
    intro:
      "Over-range and countertop microwaves both serviced. From magnetrons and door switches to dead displays, we diagnose the fault in person and give you one flat per-job price before starting.",
    problems: [
      "Microwave runs but doesn't heat",
      "Turntable not spinning",
      "Display dead or buttons not responding",
      "Sparks or arcing inside the cavity",
      "Door won't latch or sensor errors",
      "Loud buzzing during operation",
    ],
    metaTitle: "Microwave Repair Toronto & GTA | GTA Appliance Rescue",
    metaDesc:
      "Same-day microwave repair in Toronto & the GTA. Not heating, dead display or door issues? Over-range & countertop units. Call 905-906-6836.",
  },
};

export const SERVICE_FAQS = {
  refrigerator: [
    {
      q: "How quickly can you get to a fridge that's stopped cooling?",
      a: "Fridge calls are treated as priority because food spoils fast. We offer same-day appointments 7 days a week across Toronto and the GTA — call before noon and we can almost always be there the same day.",
    },
    {
      q: "Do you repair built-in and high-end refrigerators like Sub-Zero?",
      a: "Yes. Our technicians are trained across all major brands, including built-in units from Sub-Zero, Miele and Viking, as well as Samsung, LG, Whirlpool, GE and more.",
    },
    {
      q: "Is it worth repairing an older refrigerator?",
      a: "As a rule of thumb, if the repair costs less than half the price of a comparable new fridge and the unit is under 10 years old, repair usually wins. Your technician gives you an honest flat quote before any work starts — and the $80 service call is waived if you proceed.",
    },
  ],
  washer: [
    {
      q: "Why is my washer shaking violently during the spin cycle?",
      a: "Usually an unbalanced load, worn shock absorbers or broken suspension rods. If levelling the machine and redistributing the load doesn't solve it, the suspension likely needs replacement — a common same-day fix.",
    },
    {
      q: "Do you repair both front-load and top-load washers?",
      a: "Yes — front-load, top-load and high-efficiency models from all major brands, including Samsung, LG, Whirlpool, Maytag and GE.",
    },
  ],
  dryer: [
    {
      q: "Is a burning smell from my dryer dangerous?",
      a: "Treat it as urgent: stop using the dryer and unplug it. Lint buildup near the heating element is a genuine fire risk. Book a same-day visit and we'll inspect the venting, thermal fuse and element.",
    },
    {
      q: "Do you repair gas dryers as well as electric?",
      a: "Yes, our licensed technicians service both gas and electric dryers, including igniters, gas valve coils, heating elements, thermal fuses and drum components.",
    },
  ],
  dishwasher: [
    {
      q: "Why is there standing water in the bottom of my dishwasher?",
      a: "Most often a clogged filter, a blocked drain hose or a failed drain pump. Try cleaning the filter first; if water remains, the pump or hose needs attention — we carry both on the van.",
    },
    {
      q: "Can you fix a dishwasher door that won't latch?",
      a: "Yes. Latch, hinge and spring failures are common and usually repairable in one visit — far cheaper than replacing the machine.",
    },
  ],
  "stove-oven": [
    {
      q: "Do you repair gas stoves and ranges?",
      a: "Yes — our licensed technicians repair gas and electric ranges, cooktops, wall ovens and induction units, including igniters, elements, thermostats and control boards.",
    },
    {
      q: "My oven temperature seems inaccurate. Can that be fixed?",
      a: "Usually yes. A failing temperature sensor or thermostat is the typical cause, and calibration or replacement restores accurate baking temperatures.",
    },
  ],
  freezer: [
    {
      q: "How fast do I need to act if my freezer stops freezing?",
      a: "A closed, full freezer holds safe temperatures for roughly 24–48 hours. Call as soon as you notice — same-day service is available 7 days a week, so most food can be saved.",
    },
    {
      q: "Do you repair chest freezers and upright freezers?",
      a: "Yes — chest, upright and built-in freezer units from all major brands, including frost buildup, compressor and thermostat failures.",
    },
  ],
  microwave: [
    {
      q: "Is it safe to keep using a microwave that sparks?",
      a: "No. Arcing can damage the magnetron and, in rare cases, start a fire. Unplug it and book a repair — often it's just a damaged waveguide cover, an inexpensive fix.",
    },
    {
      q: "Do you repair over-the-range microwaves?",
      a: "Yes, we service both over-the-range and countertop microwaves, including magnetrons, door switches, turntable motors and control panels.",
    },
  ],
};

export const LOCATIONS = [
  {
    slug: "toronto",
    city: "Toronto",
    intro:
      "From downtown condos to family homes across the old City of Toronto, our technicians cover the entire city — whether it's a fridge in a Liberty Village high-rise or a washer in an East York basement. Same-day appointments are available 7 days a week.",
    neighbourhoods: ["Downtown", "Midtown", "East York", "York", "The Beaches", "Leslieville", "Liberty Village", "Swansea"],
  },
  {
    slug: "north-york",
    city: "North York",
    intro:
      "North York is one of our busiest service areas — condos along Yonge Street, townhomes in Don Mills and detached homes throughout. Our vans are in the area daily, which is how we offer genuine same-day repairs.",
    neighbourhoods: ["Willowdale", "Don Mills", "Downsview", "York Mills", "Bayview Village", "Jane & Finch"],
  },
  {
    slug: "etobicoke",
    city: "Etobicoke",
    intro:
      "From the lakeshore condos of Humber Bay to the family streets of Rexdale and The Kingsway, we provide fast, flat-rate appliance repair across Etobicoke — most jobs completed in a single visit.",
    neighbourhoods: ["Mimico", "Long Branch", "Humber Bay", "Rexdale", "The Kingsway", "Islington"],
  },
  {
    slug: "scarborough",
    city: "Scarborough",
    intro:
      "Agincourt to West Hill, our technicians know Scarborough well. Fully stocked vans mean your refrigerator, washer, dryer, dishwasher, stove, freezer or microwave is usually fixed the same day you call.",
    neighbourhoods: ["Agincourt", "Birch Cliff", "Guildwood", "Malvern", "Woburn", "West Hill"],
  },
  {
    slug: "mississauga",
    city: "Mississauga",
    intro:
      "Port Credit to Meadowvale, we cover all of Mississauga with same-day appliance repair. One flat per-job quote before any work begins — and the $80 service call is waived when you proceed with the repair.",
    neighbourhoods: ["Port Credit", "Streetsville", "Erin Mills", "Cooksville", "Square One area", "Meadowvale"],
  },
  {
    slug: "brampton",
    city: "Brampton",
    intro:
      "Brampton homeowners get the same fast response as downtown Toronto: licensed, insured technicians, upfront per-job pricing, and repairs backed by a 1-year parts and 30-day labour warranty.",
    neighbourhoods: ["Bramalea", "Mount Pleasant", "Downtown Brampton", "Heart Lake", "Springdale", "Castlemore"],
  },
  {
    slug: "vaughan",
    city: "Vaughan",
    intro:
      "Woodbridge, Maple, Thornhill and beyond — our Vaughan routes run daily. From new-build kitchen appliances to well-loved older machines, we repair all major brands, gas and electric.",
    neighbourhoods: ["Woodbridge", "Maple", "Thornhill", "Concord", "Kleinburg", "Vaughan Metropolitan Centre"],
  },
  {
    slug: "markham",
    city: "Markham",
    intro:
      "Unionville, Milliken, Cornell and every Markham neighbourhood in between. Book online in 60 seconds or call — a dispatcher confirms your same-day window and a stocked van comes to you.",
    neighbourhoods: ["Unionville", "Milliken", "Cornell", "Thornhill", "Berczy Village", "Markham Village"],
  },
  {
    slug: "richmond-hill",
    city: "Richmond Hill",
    intro:
      "From Bayview Hill to Oak Ridges, Richmond Hill is squarely inside our daily service area. Expect a flat quote before work starts and most repairs finished in one visit.",
    neighbourhoods: ["Bayview Hill", "Jefferson", "Oak Ridges", "Mill Pond", "Langstaff", "Elgin Mills"],
  },
];

export const GUIDES = [
  {
    slug: "refrigerator-not-cooling",
    title: "Why Is My Refrigerator Not Cooling? 7 Common Causes",
    h1: "Why Is My Refrigerator Not Cooling? 7 Common Causes",
    readTime: "4 min read",
    relatedService: "refrigerator",
    metaTitle: "Fridge Not Cooling? 7 Causes & Fixes | GTA Appliance Rescue",
    metaDesc:
      "Refrigerator not cooling but the freezer works? Learn the 7 most common causes, what you can check yourself, and when to call a Toronto fridge repair pro.",
    intro:
      "A warm fridge is a race against your groceries. Before you panic — or start shopping for a new one — here are the seven causes our technicians see most often in GTA homes, and which ones you can safely check yourself.",
    sections: [
      {
        h2: "1. Start with the simple checks",
        body: "Make sure the fridge is actually getting power, the thermostat dial hasn't been bumped to a warmer setting, and the door gaskets seal tightly all the way around. A door that doesn't seal lets cold air escape constantly, and the fridge can never catch up.",
      },
      {
        h2: "2. Dirty condenser coils",
        body: "The coils underneath or behind your fridge release heat. When they're coated in dust and pet hair, the compressor overheats and cooling drops. Unplug the fridge and gently vacuum the coils — this alone fixes a surprising number of warm-fridge calls.",
      },
      {
        h2: "3. A failed evaporator fan",
        body: "If the freezer is cold but the fridge compartment is warm, the fan that moves cold air between them has likely failed. You'll often notice the fridge getting gradually warmer over a few days. The fan motor is a common, straightforward replacement.",
      },
      {
        h2: "4. Defrost system failure",
        body: "Frost building up on the freezer's back wall points to a defrost heater, timer or sensor problem. The frost slowly chokes off airflow until the fridge section warms up. Manually defrosting buys time, but the failed part needs replacing.",
      },
      {
        h2: "5. Start relay or compressor trouble",
        body: "A clicking sound every few minutes — followed by silence — usually means the compressor is trying and failing to start. Sometimes it's an inexpensive start relay; sometimes it's the compressor itself. A proper diagnosis tells you which before you spend anything.",
      },
      {
        h2: "6. Blocked air vents inside the fridge",
        body: "Food pressed against the interior vents blocks cold air circulation. Rearrange items so air can move freely between the freezer and fridge compartments, and don't overpack.",
      },
      {
        h2: "7. When to call a professional",
        body: "Anything involving the sealed refrigerant system, the compressor, or electrical components needs a licensed technician — these aren't safe DIY territory. Our $80 in-person diagnosis pinpoints the exact fault, and that fee is waived entirely when you proceed with the repair.",
      },
    ],
  },
  {
    slug: "washer-wont-drain",
    title: "Washing Machine Won't Drain? 5 Things to Check",
    h1: "Washing Machine Won't Drain? 5 Things to Check",
    readTime: "3 min read",
    relatedService: "washer",
    metaTitle: "Washer Won't Drain? 5 Things to Check | GTA Appliance Rescue",
    metaDesc:
      "Washing machine full of water and won't drain? Check these 5 common causes first — and learn when a drain pump or lid switch repair is the real fix.",
    intro:
      "A washer full of soggy clothes and standing water is one of the most common calls we get across Toronto and the GTA. Here's how to narrow down the cause — three of these checks take under five minutes.",
    sections: [
      {
        h2: "1. Check the drain hose",
        body: "Pull the washer out slightly and inspect the drain hose for kinks, crushing or clogs. Also confirm it's installed at the right height — a hose pushed too far down the standpipe can cause siphoning and draining problems.",
      },
      {
        h2: "2. Clean the pump filter",
        body: "Most front-loaders (and many top-loaders) have a small access panel near the bottom front. Place a towel and shallow tray underneath, open it, and clear out the coins, hair pins, lint and debris that accumulate there. A blocked filter is the single most common cause of no-drain calls.",
      },
      {
        h2: "3. Test the lid switch or door lock",
        body: "Washers refuse to spin or drain if they think the door is open. If the machine fills and washes but stops before the drain and spin, a worn lid switch or door-lock assembly is a likely culprit — an inexpensive part to replace.",
      },
      {
        h2: "4. Listen for the drain pump",
        body: "During the drain cycle you should hear a low hum from the pump. Silence usually means a failed pump or a jammed impeller; a loud grinding noise means something is stuck inside it. Either way, the pump needs service.",
      },
      {
        h2: "5. Know when to stop",
        body: "If the filter is clean and the hose is clear but the washer still won't drain, the fault is electrical or mechanical — pump, control board or wiring. Our technicians diagnose it in person for an $80 service call, waived when you proceed with the repair, and most drain repairs finish in one visit.",
      },
    ],
  },
  {
    slug: "dryer-not-heating",
    title: "Dryer Not Heating? Common Causes & What to Check First",
    h1: "Dryer Not Heating? Common Causes & What to Check First",
    readTime: "4 min read",
    relatedService: "dryer",
    metaTitle: "Dryer Not Heating? Causes & Fixes | GTA Appliance Rescue",
    metaDesc:
      "Dryer runs but clothes stay damp? Learn the most common no-heat causes — from a tripped breaker to a blown thermal fuse — and when to call a dryer repair pro.",
    intro:
      "A dryer that tumbles but won't heat wastes hours and drives up your hydro bill. Some causes are simple checks you can do in minutes; others — especially anything involving gas or 240V wiring — belong to a licensed technician.",
    sections: [
      {
        h2: "1. Check the settings and the breaker",
        body: "Make sure you haven't selected an air-fluff or no-heat cycle. Then check your electrical panel: electric dryers run on a double breaker, and one half can trip — the dryer still tumbles on 120V but the heater gets no power. Flip the dryer breaker fully off and on.",
      },
      {
        h2: "2. Clear the lint — all of it",
        body: "A clogged lint screen or blocked vent duct restricts airflow, causing poor drying and overheating. Clean the lint trap every load, and check the vent hose behind the dryer and the exterior vent flap. Beyond performance, lint buildup near the heating element is a genuine fire risk.",
      },
      {
        h2: "3. The thermal fuse",
        body: "When a dryer overheats, a one-time thermal fuse blows to protect your home — and the heat stops until it's replaced. A blown fuse almost always signals a venting problem that needs fixing too, or the new fuse will blow again.",
      },
      {
        h2: "4. Heating element (electric) or igniter (gas)",
        body: "Electric dryers use a coil element that burns out with age; gas dryers use an igniter and valve coils that weaken over time. Both are among the most common repairs we complete, usually in a single visit with parts on the van.",
      },
      {
        h2: "5. When to call a professional",
        body: "Gas lines and 240V circuits aren't DIY territory. We service both gas and electric dryers across Toronto and the GTA with same-day appointments — the $80 diagnosis is waived when you proceed with the repair.",
      },
    ],
  },
  {
    slug: "repair-or-replace",
    title: "Repair or Replace? How to Decide for an Aging Appliance",
    h1: "Repair or Replace? How to Decide for an Aging Appliance",
    readTime: "3 min read",
    relatedService: null,
    metaTitle: "Repair or Replace an Appliance? How to Decide | GTA Appliance Rescue",
    metaDesc:
      "Should you repair or replace your fridge, washer, dryer or dishwasher? The 50% rule, real appliance lifespans, and how an honest diagnosis saves you money.",
    intro:
      "Every day we help GTA homeowners answer this exact question with real numbers instead of guesswork. Here's the framework our technicians use — so you can decide with confidence before spending a dollar.",
    sections: [
      {
        h2: "The 50% rule",
        body: "If a repair costs less than half the price of a comparable new appliance — and the unit is in the first two-thirds of its expected lifespan — repairing almost always wins. A $180 pump replacement on a $1,100 washer is an easy yes.",
      },
      {
        h2: "Know the typical lifespans",
        body: "Refrigerators generally run 10–15 years, washers and dryers 10–13, dishwashers 9–12, stoves and ovens 13–15, and microwaves 7–10. A 6-year-old dryer with a blown fuse has years of life left; a 16-year-old fridge with a failed compressor is a tougher call.",
      },
      {
        h2: "Factor in energy efficiency",
        body: "Newer appliances use meaningfully less electricity and water than models from 15+ years ago. If an old appliance is both failing and inefficient, the hydro savings can tip the scales toward replacement.",
      },
      {
        h2: "Check warranty and parts availability",
        body: "An appliance under manufacturer warranty may be repaired at no cost to you. For older or discontinued models, parts availability matters — we'll tell you honestly if parts are scarce before you commit to anything.",
      },
      {
        h2: "Get an honest diagnosis first",
        body: "Most people guess wrong about what's broken. Our $80 in-person diagnosis gives you the exact fault and a flat repair quote — and the fee is waived when you proceed. If replacement genuinely makes more sense, we'll tell you that too.",
      },
    ],
  },
];

export const HERO_IMAGE =
  "https://images.unsplash.com/photo-1639405069836-f82aa6dcb900?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODh8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBzdGFpbmxlc3MlMjByZWZyaWdlcmF0b3IlMjBraXRjaGVuJTIwaW50ZXJpb3J8ZW58MHx8fHwxNzg3ODY0NTk5fDA&ixlib=rb-4.1.0&q=85";

export const TORONTO_SKYLINE =
  "https://images.unsplash.com/photo-1543962226-818f4301073f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzR8MHwxfHNlYXJjaHwyfHx0b3JvbnRvJTIwc2t5bGluZSUyMENOJTIwdG93ZXIlMjBjaXR5c2NhcGV8ZW58MHx8fHwxNzg3ODY0NTk5fDA&ixlib=rb-4.1.0&q=85";
